<template>
  <loading-container :state="state" :i18nErrorMessage="getI18nErrorString()" :error-uuid="errorUuid" >
    <Karte
      :c-centers="filteredCenter"
    />
  </loading-container>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import LoadingMixin from "../mixins/LoadingMixin";
import { LoadingState } from "../utils/loadingUtils";
import LoadingContainer from '../components/structure/LoadingContainer.vue';
import Karte from '@/components/ergebnisliste/Karte.vue'
import counselingCenterService from "@/services/counselingCenterService";
import { mapActions } from "vuex";
import {CounselingCenterSearchResultDto, ObjectStatus} from '@/generated/openapi/api'

export default defineComponent({
  name: "WidgetHomeKarte",
  components:{
    LoadingContainer,
    Karte
  },
  mixins: [
    LoadingMixin
  ],
  emits: ['submit'],
  methods: {
    ...mapActions(['getAllLookUpValues'])
  },
  data() {
    return {
      filteredCenter: [] as CounselingCenterSearchResultDto[]
    }
  },
  props: {
  },
  computed: {
  },
  mounted() {
    this.state = LoadingState.loading

    this.getAllLookUpValues().then(_ => {
      counselingCenterService.getCounselingCenters('', undefined,undefined,undefined,undefined,ObjectStatus.Active, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined,undefined, 1000,undefined,'',undefined, undefined, undefined, undefined, undefined).then(result => {
        this.filteredCenter = result.content as any

        const headingElement = document.getElementById("karteHeading");
        if (headingElement && headingElement.classList.contains('show-count')) {
          const totalCount = result.totalCount || 0;
          const allCourts = this.$store.state.rawLookUpValuesCourt;

          if (allCourts) {
            const allByCourt = this.filteredCenter.filter(center => {
              if (center.lookupValueIds) {
                return center.lookupValueIds.some(id => {
                  if (allCourts.get(id) == true) {
                    return true
                  } else {
                    return false
                  }
                })
              } else {
                return true;
              }
            })
            headingElement.prepend(totalCount - allByCourt.length + " ")
          }
        }

        this.state = LoadingState.success
      }).catch(() => {
        this.state = LoadingState.success
      })
    }).catch(() => {
      // error
    })

  }
})
</script>

<style scoped>

</style>
